import React, { useState } from 'react';
import { FaBook, FaFileAlt, FaPencilAlt, FaCalendarAlt, FaCheckCircle, FaDownload, FaUserGraduate, FaClipboardList, FaGraduationCap, FaChartLine, FaLightbulb, FaTrophy, FaUsers, FaClock, FaRupeeSign } from 'react-icons/fa';

const JNVSTPage = () => {
  const [selectedClass, setSelectedClass] = useState('6th');

  const classData = {
    '6th': {
      eligibility: "Students currently studying in Class 5th",
      ageLimit: "9-13 years as on the date of admission",
      subjects: ["Mental Ability", "Arithmetic", "Language Test"],
      examPattern: {
        totalMarks: 100,
        duration: "2 Hours",
        sections: [
          { name: "Mental Ability", marks: 40, questions: 40 },
          { name: "Arithmetic", marks: 40, questions: 40 },
          { name: "Language Test", marks: 20, questions: 20 }
        ]
      }
    },
    '9th': {
      eligibility: "Students currently studying in Class 8th",
      ageLimit: "13-16 years as on the date of admission",
      subjects: ["English", "Hindi", "Mathematics", "Science", "Social Studies"],
      examPattern: {
        totalMarks: 100,
        duration: "2.5 Hours",
        sections: [
          { name: "English", marks: 15, questions: 15 },
          { name: "Hindi", marks: 15, questions: 15 },
          { name: "Mathematics", marks: 25, questions: 25 },
          { name: "Science", marks: 25, questions: 25 },
          { name: "Social Studies", marks: 20, questions: 20 }
        ]
      }
    },
    '11th': {
      eligibility: "Students who have passed Class 10th",
      ageLimit: "14-18 years as on the date of admission",
      subjects: ["English", "Mathematics/Biology", "Physics", "Chemistry"],
      examPattern: {
        totalMarks: 100,
        duration: "3 Hours",
        sections: [
          { name: "English", marks: 20, questions: 20 },
          { name: "Mathematics/Biology", marks: 30, questions: 30 },
          { name: "Physics", marks: 25, questions: 25 },
          { name: "Chemistry", marks: 25, questions: 25 }
        ]
      }
    }
  };

  const syllabus = {
    '6th': [
      {
        subject: "Mental Ability",
        topics: ["Pattern Completion", "Figure Matching", "Analogy", "Classification", "Series", "Coding-Decoding", "Mirror Images", "Water Images", "Direction Sense", "Ranking"]
      },
      {
        subject: "Arithmetic",
        topics: ["Number System", "HCF & LCM", "Fractions & Decimals", "Ratio & Proportion", "Percentage", "Profit & Loss", "Simple Interest", "Time & Distance", "Average", "Geometry Basics"]
      },
      {
        subject: "Language Test",
        topics: ["Reading Comprehension", "Synonyms & Antonyms", "Grammar", "Sentence Formation", "One Word Substitution", "Idioms & Phrases"]
      }
    ],
    '9th': [
      {
        subject: "English",
        topics: ["Reading Comprehension", "Grammar", "Vocabulary", "Writing Skills", "Active-Passive Voice", "Direct-Indirect Speech"]
      },
      {
        subject: "Hindi",
        topics: ["अपठित गद्यांश", "व्याकरण", "शब्द ज्ञान", "मुहावरे एवं लोकोक्तियाँ", "वर्तनी", "रचना"]
      },
      {
        subject: "Mathematics",
        topics: ["Number System", "Algebra", "Geometry", "Mensuration", "Statistics", "Probability", "Trigonometry Basics", "Linear Equations"]
      },
      {
        subject: "Science",
        topics: ["Physics: Motion, Force, Energy, Light, Sound", "Chemistry: Matter, Atoms, Molecules, Chemical Reactions", "Biology: Cell, Tissues, Reproduction, Health"]
      },
      {
        subject: "Social Studies",
        topics: ["History: Ancient & Medieval India", "Geography: Earth, Climate, Resources", "Civics: Constitution, Democracy", "Economics: Basic Concepts"]
      }
    ],
    '11th': [
      {
        subject: "English",
        topics: ["Advanced Reading Comprehension", "Grammar & Usage", "Vocabulary", "Writing Skills", "Essay Writing", "Letter Writing"]
      },
      {
        subject: "Mathematics",
        topics: ["Algebra", "Trigonometry", "Coordinate Geometry", "Calculus Basics", "Statistics", "Probability", "3D Geometry", "Vectors"]
      },
      {
        subject: "Biology (For Medical Stream)",
        topics: ["Cell Biology", "Genetics", "Evolution", "Plant Physiology", "Animal Physiology", "Ecology", "Biotechnology"]
      },
      {
        subject: "Physics",
        topics: ["Mechanics", "Thermodynamics", "Waves & Optics", "Electricity & Magnetism", "Modern Physics"]
      },
      {
        subject: "Chemistry",
        topics: ["Physical Chemistry", "Organic Chemistry", "Inorganic Chemistry", "Chemical Bonding", "Equilibrium", "Redox Reactions"]
      }
    ]
  };

  const recommendedBooks = {
    '6th': [
      { name: "Navodaya Vidyalaya Class VI Entrance Exam Guide", publisher: "Arihant Publications" },
      { name: "JNVST Class 6 Complete Study Package", publisher: "Youth Competition Times" },
      { name: "Mental Ability for Class 6", publisher: "MTG Learning Media" },
      { name: "NCERT Books (Class 5)", publisher: "NCERT" }
    ],
    '9th': [
      { name: "Navodaya Vidyalaya Class IX Entrance Exam", publisher: "Arihant Publications" },
      { name: "JNVST Class 9 Complete Guide", publisher: "Youth Competition Times" },
      { name: "NCERT Books (Class 8) - All Subjects", publisher: "NCERT" },
      { name: "Mental Ability Test Series", publisher: "Disha Publications" }
    ],
    '11th': [
      { name: "Navodaya Vidyalaya Class XI Lateral Entry Test", publisher: "Arihant Publications" },
      { name: "NCERT Books (Class 10) - All Subjects", publisher: "NCERT" },
      { name: "Previous Year Question Papers", publisher: "Various" },
      { name: "Physics, Chemistry, Biology/Math Guides", publisher: "MTG/Arihant" }
    ]
  };

  const importantDates = [
    { event: "Notification Release", date: "November (Tentative)" },
    { event: "Online Registration Start", date: "December - January" },
    { event: "Last Date to Apply", date: "January End" },
    { event: "Admit Card Release", date: "March - April" },
    { event: "Exam Date", date: "April - May" },
    { event: "Result Declaration", date: "May - June" },
    { event: "Admission Process", date: "June - July" }
  ];

  const features = [
    { icon: <FaGraduationCap />, title: "Expert Faculty", desc: "Experienced teachers with proven track record" },
    { icon: <FaBook />, title: "Comprehensive Study Material", desc: "Updated syllabus-based content" },
    { icon: <FaChartLine />, title: "Mock Tests", desc: "Regular practice tests & performance analysis" },
    { icon: <FaLightbulb />, title: "Smart Learning", desc: "Interactive teaching methods" },
    { icon: <FaTrophy />, title: "Success Rate", desc: "High selection ratio in JNVST" },
    { icon: <FaUsers />, title: "Small Batches", desc: "Personal attention to each student" }
  ];

  return (
    <div style={{ background: '#f8f9fa', minHeight: '100vh' }}>
      {/* Hero Section */}
      <div style={{
        background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
        padding: '80px 20px 60px',
        color: 'white',
        textAlign: 'center'
      }}>
        <div style={{ maxWidth: '1200px', margin: '0 auto' }}>
          <h1 style={{ fontSize: '3rem', fontWeight: 'bold', marginBottom: '20px' }}>
            Jawahar Navodaya Vidyalaya Selection Test (JNVST)
          </h1>
          <p style={{ fontSize: '1.3rem', marginBottom: '30px', opacity: 0.95 }}>
            Get admission to India's premier residential schools - Navodaya Vidyalayas
          </p>
          <div style={{ display: 'flex', gap: '15px', justifyContent: 'center', flexWrap: 'wrap' }}>
            <button
              onClick={() => window.location.href = '/register'}
              style={{
                background: 'white',
                color: '#667eea',
                padding: '15px 40px',
                borderRadius: '30px',
                border: 'none',
                fontSize: '1.1rem',
                fontWeight: 'bold',
                cursor: 'pointer',
                boxShadow: '0 8px 20px rgba(0,0,0,0.2)',
                transition: 'all 0.3s ease'
              }}
              onMouseEnter={(e) => e.currentTarget.style.transform = 'translateY(-3px)'}
              onMouseLeave={(e) => e.currentTarget.style.transform = 'translateY(0)'}
            >
              Register Now
            </button>
            <button
              onClick={() => document.getElementById('syllabus').scrollIntoView({ behavior: 'smooth' })}
              style={{
                background: 'rgba(255,255,255,0.2)',
                color: 'white',
                padding: '15px 40px',
                borderRadius: '30px',
                border: '2px solid white',
                fontSize: '1.1rem',
                fontWeight: 'bold',
                cursor: 'pointer',
                transition: 'all 0.3s ease'
              }}
              onMouseEnter={(e) => {
                e.currentTarget.style.background = 'white';
                e.currentTarget.style.color = '#667eea';
              }}
              onMouseLeave={(e) => {
                e.currentTarget.style.background = 'rgba(255,255,255,0.2)';
                e.currentTarget.style.color = 'white';
              }}
            >
              View Syllabus
            </button>
          </div>
        </div>
      </div>

      {/* Class Selection Tabs */}
      <div style={{ 
        background: 'white', 
        padding: '30px 20px',
        boxShadow: '0 4px 15px rgba(0,0,0,0.08)',
        position: 'sticky',
        top: '0',
        zIndex: 100
      }}>
        <div style={{ maxWidth: '1200px', margin: '0 auto' }}>
          <div style={{ 
            display: 'flex', 
            gap: '15px', 
            justifyContent: 'center',
            flexWrap: 'wrap'
          }}>
            {['6th', '9th', '11th'].map(cls => (
              <button
                key={cls}
                onClick={() => setSelectedClass(cls)}
                style={{
                  padding: '15px 40px',
                  borderRadius: '12px',
                  border: 'none',
                  background: selectedClass === cls 
                    ? 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)' 
                    : '#f0f0f0',
                  color: selectedClass === cls ? 'white' : '#333',
                  fontSize: '1.1rem',
                  fontWeight: 'bold',
                  cursor: 'pointer',
                  transition: 'all 0.3s ease',
                  boxShadow: selectedClass === cls ? '0 4px 15px rgba(102,126,234,0.4)' : 'none'
                }}
                onMouseEnter={(e) => {
                  if (selectedClass !== cls) {
                    e.currentTarget.style.background = '#e0e0e0';
                  }
                }}
                onMouseLeave={(e) => {
                  if (selectedClass !== cls) {
                    e.currentTarget.style.background = '#f0f0f0';
                  }
                }}
              >
                Class {cls}
              </button>
            ))}
          </div>
        </div>
      </div>

      <div style={{ maxWidth: '1200px', margin: '0 auto', padding: '40px 20px' }}>
        
        {/* Overview Section */}
        <section style={{ marginBottom: '60px' }}>
          <h2 style={{ 
            fontSize: '2.5rem', 
            fontWeight: 'bold', 
            marginBottom: '30px',
            color: '#2c3e50',
            textAlign: 'center'
          }}>
            About JNVST for Class {selectedClass}
          </h2>
          
          <div style={{ 
            display: 'grid', 
            gridTemplateColumns: 'repeat(auto-fit, minmax(300px, 1fr))',
            gap: '25px',
            marginBottom: '40px'
          }}>
            <div style={{
              background: 'white',
              padding: '30px',
              borderRadius: '15px',
              boxShadow: '0 4px 15px rgba(0,0,0,0.08)',
              border: '1px solid #e8e8e8'
            }}>
              <div style={{ 
                fontSize: '2.5rem', 
                color: '#667eea',
                marginBottom: '15px'
              }}>
                <FaUserGraduate />
              </div>
              <h3 style={{ fontSize: '1.3rem', fontWeight: 'bold', marginBottom: '10px', color: '#2c3e50' }}>
                Eligibility
              </h3>
              <p style={{ color: '#666', lineHeight: '1.6', margin: 0 }}>
                {classData[selectedClass].eligibility}
              </p>
            </div>

            <div style={{
              background: 'white',
              padding: '30px',
              borderRadius: '15px',
              boxShadow: '0 4px 15px rgba(0,0,0,0.08)',
              border: '1px solid #e8e8e8'
            }}>
              <div style={{ 
                fontSize: '2.5rem', 
                color: '#f093fb',
                marginBottom: '15px'
              }}>
                <FaClock />
              </div>
              <h3 style={{ fontSize: '1.3rem', fontWeight: 'bold', marginBottom: '10px', color: '#2c3e50' }}>
                Age Limit
              </h3>
              <p style={{ color: '#666', lineHeight: '1.6', margin: 0 }}>
                {classData[selectedClass].ageLimit}
              </p>
            </div>

            <div style={{
              background: 'white',
              padding: '30px',
              borderRadius: '15px',
              boxShadow: '0 4px 15px rgba(0,0,0,0.08)',
              border: '1px solid #e8e8e8'
            }}>
              <div style={{ 
                fontSize: '2.5rem', 
                color: '#43e97b',
                marginBottom: '15px'
              }}>
                <FaRupeeSign />
              </div>
              <h3 style={{ fontSize: '1.3rem', fontWeight: 'bold', marginBottom: '10px', color: '#2c3e50' }}>
                Application Fee
              </h3>
              <p style={{ color: '#666', lineHeight: '1.6', margin: 0 }}>
                No Application Fee (Free for all categories)
              </p>
            </div>
          </div>
        </section>

        {/* Exam Pattern */}
        <section style={{ marginBottom: '60px' }}>
          <h2 style={{ 
            fontSize: '2.5rem', 
            fontWeight: 'bold', 
            marginBottom: '30px',
            color: '#2c3e50',
            textAlign: 'center'
          }}>
            <FaClipboardList style={{ marginRight: '10px', color: '#667eea' }} />
            Exam Pattern
          </h2>

          <div style={{
            background: 'white',
            padding: '40px',
            borderRadius: '15px',
            boxShadow: '0 4px 15px rgba(0,0,0,0.08)'
          }}>
            <div style={{ 
              display: 'grid',
              gridTemplateColumns: 'repeat(auto-fit, minmax(200px, 1fr))',
              gap: '20px',
              marginBottom: '30px'
            }}>
              <div style={{ textAlign: 'center', padding: '20px' }}>
                <div style={{ fontSize: '2.5rem', fontWeight: 'bold', color: '#667eea' }}>
                  {classData[selectedClass].examPattern.totalMarks}
                </div>
                <div style={{ color: '#666', marginTop: '5px' }}>Total Marks</div>
              </div>
              <div style={{ textAlign: 'center', padding: '20px' }}>
                <div style={{ fontSize: '2.5rem', fontWeight: 'bold', color: '#f093fb' }}>
                  {classData[selectedClass].examPattern.duration}
                </div>
                <div style={{ color: '#666', marginTop: '5px' }}>Duration</div>
              </div>
              <div style={{ textAlign: 'center', padding: '20px' }}>
                <div style={{ fontSize: '2.5rem', fontWeight: 'bold', color: '#43e97b' }}>
                  Objective
                </div>
                <div style={{ color: '#666', marginTop: '5px' }}>Question Type</div>
              </div>
            </div>

            <div style={{ overflow: 'auto' }}>
              <table style={{ 
                width: '100%', 
                borderCollapse: 'collapse',
                fontSize: '1rem'
              }}>
                <thead>
                  <tr style={{ background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)', color: 'white' }}>
                    <th style={{ padding: '15px', textAlign: 'left', borderRadius: '8px 0 0 0' }}>Section</th>
                    <th style={{ padding: '15px', textAlign: 'center' }}>Questions</th>
                    <th style={{ padding: '15px', textAlign: 'center', borderRadius: '0 8px 0 0' }}>Marks</th>
                  </tr>
                </thead>
                <tbody>
                  {classData[selectedClass].examPattern.sections.map((section, idx) => (
                    <tr key={idx} style={{ 
                      background: idx % 2 === 0 ? '#f8f9fa' : 'white',
                      borderBottom: '1px solid #e0e0e0'
                    }}>
                      <td style={{ padding: '15px', fontWeight: '600' }}>{section.name}</td>
                      <td style={{ padding: '15px', textAlign: 'center' }}>{section.questions}</td>
                      <td style={{ padding: '15px', textAlign: 'center', fontWeight: 'bold', color: '#667eea' }}>
                        {section.marks}
                      </td>
                    </tr>
                  ))}
                  <tr style={{ background: '#667eea', color: 'white', fontWeight: 'bold' }}>
                    <td style={{ padding: '15px' }}>Total</td>
                    <td style={{ padding: '15px', textAlign: 'center' }}>
                      {classData[selectedClass].examPattern.sections.reduce((sum, s) => sum + s.questions, 0)}
                    </td>
                    <td style={{ padding: '15px', textAlign: 'center' }}>
                      {classData[selectedClass].examPattern.totalMarks}
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </section>

        {/* Syllabus Section */}
        <section id="syllabus" style={{ marginBottom: '60px' }}>
          <h2 style={{ 
            fontSize: '2.5rem', 
            fontWeight: 'bold', 
            marginBottom: '30px',
            color: '#2c3e50',
            textAlign: 'center'
          }}>
            <FaBook style={{ marginRight: '10px', color: '#667eea' }} />
            Detailed Syllabus
          </h2>

          <div style={{
            display: 'grid',
            gridTemplateColumns: 'repeat(auto-fit, minmax(300px, 1fr))',
            gap: '25px'
          }}>
            {syllabus[selectedClass].map((subj, idx) => (
              <div key={idx} style={{
                background: 'white',
                padding: '30px',
                borderRadius: '15px',
                boxShadow: '0 4px 15px rgba(0,0,0,0.08)',
                border: '1px solid #e8e8e8'
              }}>
                <h3 style={{ 
                  fontSize: '1.5rem', 
                  fontWeight: 'bold', 
                  marginBottom: '20px',
                  color: '#667eea',
                  borderBottom: '3px solid #667eea',
                  paddingBottom: '10px'
                }}>
                  {subj.subject}
                </h3>
                <ul style={{ 
                  listStyle: 'none', 
                  padding: 0,
                  margin: 0
                }}>
                  {subj.topics.map((topic, i) => (
                    <li key={i} style={{ 
                      padding: '10px 0',
                      borderBottom: i < subj.topics.length - 1 ? '1px solid #f0f0f0' : 'none',
                      display: 'flex',
                      alignItems: 'flex-start',
                      gap: '10px',
                      color: '#555'
                    }}>
                      <FaCheckCircle style={{ color: '#43e97b', marginTop: '4px', flexShrink: 0 }} />
                      <span>{topic}</span>
                    </li>
                  ))}
                </ul>
              </div>
            ))}
          </div>
        </section>

        {/* Recommended Books */}
        <section style={{ marginBottom: '60px' }}>
          <h2 style={{ 
            fontSize: '2.5rem', 
            fontWeight: 'bold', 
            marginBottom: '30px',
            color: '#2c3e50',
            textAlign: 'center'
          }}>
            <FaBook style={{ marginRight: '10px', color: '#667eea' }} />
            Recommended Books
          </h2>

          <div style={{
            background: 'white',
            padding: '40px',
            borderRadius: '15px',
            boxShadow: '0 4px 15px rgba(0,0,0,0.08)'
          }}>
            <div style={{ 
              display: 'grid',
              gridTemplateColumns: 'repeat(auto-fill, minmax(280px, 1fr))',
              gap: '20px'
            }}>
              {recommendedBooks[selectedClass].map((book, idx) => (
                <div key={idx} style={{
                  padding: '20px',
                  border: '2px solid #e8e8e8',
                  borderRadius: '12px',
                  transition: 'all 0.3s ease',
                  cursor: 'pointer'
                }}
                onMouseEnter={(e) => {
                  e.currentTarget.style.borderColor = '#667eea';
                  e.currentTarget.style.boxShadow = '0 4px 15px rgba(102,126,234,0.2)';
                }}
                onMouseLeave={(e) => {
                  e.currentTarget.style.borderColor = '#e8e8e8';
                  e.currentTarget.style.boxShadow = 'none';
                }}>
                  <div style={{ 
                    fontSize: '2rem', 
                    color: '#667eea',
                    marginBottom: '10px'
                  }}>
                    <FaBook />
                  </div>
                  <h4 style={{ 
                    fontSize: '1.1rem', 
                    fontWeight: 'bold',
                    marginBottom: '8px',
                    color: '#2c3e50'
                  }}>
                    {book.name}
                  </h4>
                  <p style={{ 
                    color: '#666',
                    fontSize: '0.9rem',
                    margin: 0
                  }}>
                    By {book.publisher}
                  </p>
                </div>
              ))}
            </div>
          </div>
        </section>

        {/* Important Dates */}
        <section style={{ marginBottom: '60px' }}>
          <h2 style={{ 
            fontSize: '2.5rem', 
            fontWeight: 'bold', 
            marginBottom: '30px',
            color: '#2c3e50',
            textAlign: 'center'
          }}>
            <FaCalendarAlt style={{ marginRight: '10px', color: '#667eea' }} />
            Important Dates 2025
          </h2>

          <div style={{
            background: 'white',
            padding: '40px',
            borderRadius: '15px',
            boxShadow: '0 4px 15px rgba(0,0,0,0.08)'
          }}>
            <div style={{ overflow: 'auto' }}>
              <table style={{ 
                width: '100%', 
                borderCollapse: 'collapse',
                fontSize: '1.1rem'
              }}>
                <thead>
                  <tr style={{ background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)', color: 'white' }}>
                    <th style={{ padding: '20px', textAlign: 'left', borderRadius: '8px 0 0 0' }}>Event</th>
                    <th style={{ padding: '20px', textAlign: 'right', borderRadius: '0 8px 0 0' }}>Date</th>
                  </tr>
                </thead>
                <tbody>
                  {importantDates.map((item, idx) => (
                    <tr key={idx} style={{ 
                      background: idx % 2 === 0 ? '#f8f9fa' : 'white',
                      borderBottom: '1px solid #e0e0e0'
                    }}>
                      <td style={{ padding: '20px', fontWeight: '600', color: '#2c3e50' }}>
                        <FaCalendarAlt style={{ marginRight: '10px', color: '#667eea' }} />
                        {item.event}
                      </td>
                      <td style={{ padding: '20px', textAlign: 'right', color: '#666' }}>
                        {item.date}
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          </div>
        </section>

        {/* Previous Year Papers */}
        <section style={{ marginBottom: '60px' }}>
          <h2 style={{ 
            fontSize: '2.5rem', 
            fontWeight: 'bold', 
            marginBottom: '30px',
            color: '#2c3e50',
            textAlign: 'center'
          }}>
            <FaFileAlt style={{ marginRight: '10px', color: '#667eea' }} />
            Previous Year Question Papers
          </h2>

          <div style={{
            background: 'white',
            padding: '40px',
            borderRadius: '15px',
            boxShadow: '0 4px 15px rgba(0,0,0,0.08)'
          }}>
            <div style={{ 
              display: 'grid',
              gridTemplateColumns: 'repeat(auto-fill, minmax(250px, 1fr))',
              gap: '20px'
            }}>
              {['2024', '2023', '2022', '2021', '2020', '2019'].map((year) => (
                <button key={year} style={{
                  padding: '25px',
                  borderRadius: '12px',
                  border: '2px solid #e8e8e8',
                  background: 'white',
                  cursor: 'pointer',
                  transition: 'all 0.3s ease',
                  fontSize: '1.1rem',
                  fontWeight: 'bold',
                  color: '#2c3e50',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'space-between'
                }}
                onMouseEnter={(e) => {
                  e.currentTarget.style.background = 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)';
                  e.currentTarget.style.color = 'white';
                  e.currentTarget.style.borderColor = 'transparent';
                  e.currentTarget.style.transform = 'translateY(-5px)';
                }}
                onMouseLeave={(e) => {
                  e.currentTarget.style.background = 'white';
                  e.currentTarget.style.color = '#2c3e50';
                  e.currentTarget.style.borderColor = '#e8e8e8';
                  e.currentTarget.style.transform = 'translateY(0)';
                }}>
                  <span>JNVST {year}</span>
                  <FaDownload />
                </button>
              ))}
            </div>
            <p style={{ 
              textAlign: 'center', 
              marginTop: '30px',
              color: '#666',
              fontSize: '1rem'
            }}>
              Click on any year to download the question paper with solutions
            </p>
          </div>
        </section>

        {/* Why Choose Our Course */}
        <section style={{ marginBottom: '60px' }}>
          <h2 style={{ 
            fontSize: '2.5rem', 
            fontWeight: 'bold', 
            marginBottom: '30px',
            color: '#2c3e50',
            textAlign: 'center'
          }}>
            Why Choose Our JNVST Preparation Course?
          </h2>

          <div style={{
            display: 'grid',
            gridTemplateColumns: 'repeat(auto-fit, minmax(300px, 1fr))',
            gap: '30px'
          }}>
            {features.map((feature, idx) => (
              <div key={idx} style={{
                background: 'white',
                padding: '35px',
                borderRadius: '15px',
                boxShadow: '0 4px 15px rgba(0,0,0,0.08)',
                textAlign: 'center',
                transition: 'all 0.3s ease',
                cursor: 'pointer',
                border: '2px solid transparent'
              }}
              onMouseEnter={(e) => {
                e.currentTarget.style.transform = 'translateY(-10px)';
                e.currentTarget.style.boxShadow = '0 12px 30px rgba(102,126,234,0.2)';
                e.currentTarget.style.borderColor = '#667eea';
              }}
              onMouseLeave={(e) => {
                e.currentTarget.style.transform = 'translateY(0)';
                e.currentTarget.style.boxShadow = '0 4px 15px rgba(0,0,0,0.08)';
                e.currentTarget.style.borderColor = 'transparent';
              }}>
                <div style={{ 
                  fontSize: '3.5rem',
                  color: '#667eea',
                  marginBottom: '20px'
                }}>
                  {feature.icon}
                </div>
                <h3 style={{ 
                  fontSize: '1.4rem',
                  fontWeight: 'bold',
                  marginBottom: '15px',
                  color: '#2c3e50'
                }}>
                  {feature.title}
                </h3>
                <p style={{ 
                  color: '#666',
                  lineHeight: '1.6',
                  margin: 0,
                  fontSize: '1rem'
                }}>
                  {feature.desc}
                </p>
              </div>
            ))}
          </div>
        </section>

        {/* Mock Test Section */}
        <section style={{ marginBottom: '60px' }}>
          <h2 style={{ 
            fontSize: '2.5rem', 
            fontWeight: 'bold', 
            marginBottom: '30px',
            color: '#2c3e50',
            textAlign: 'center'
          }}>
            <FaPencilAlt style={{ marginRight: '10px', color: '#667eea' }} />
            Practice Mock Tests
          </h2>

          <div style={{
            background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
            padding: '50px',
            borderRadius: '20px',
            textAlign: 'center',
            color: 'white'
          }}>
            <h3 style={{ 
              fontSize: '2rem',
              fontWeight: 'bold',
              marginBottom: '20px'
            }}>
              Test Your Preparation
            </h3>
            <p style={{ 
              fontSize: '1.2rem',
              marginBottom: '30px',
              opacity: 0.95
            }}>
              Take free mock tests designed exactly like JNVST exam pattern
            </p>
            <div style={{ 
              display: 'flex',
              gap: '20px',
              justifyContent: 'center',
              flexWrap: 'wrap'
            }}>
              <button style={{
                background: 'white',
                color: '#667eea',
                padding: '15px 40px',
                borderRadius: '30px',
                border: 'none',
                fontSize: '1.1rem',
                fontWeight: 'bold',
                cursor: 'pointer',
                boxShadow: '0 8px 20px rgba(0,0,0,0.2)',
                transition: 'all 0.3s ease'
              }}
              onMouseEnter={(e) => e.currentTarget.style.transform = 'scale(1.05)'}
              onMouseLeave={(e) => e.currentTarget.style.transform = 'scale(1)'}>
                Start Free Mock Test
              </button>
              <button style={{
                background: 'rgba(255,255,255,0.2)',
                color: 'white',
                padding: '15px 40px',
                borderRadius: '30px',
                border: '2px solid white',
                fontSize: '1.1rem',
                fontWeight: 'bold',
                cursor: 'pointer',
                transition: 'all 0.3s ease'
              }}
              onMouseEnter={(e) => {
                e.currentTarget.style.background = 'white';
                e.currentTarget.style.color = '#667eea';
              }}
              onMouseLeave={(e) => {
                e.currentTarget.style.background = 'rgba(255,255,255,0.2)';
                e.currentTarget.style.color = 'white';
              }}>
                View Test Series
              </button>
            </div>
          </div>
        </section>

        {/* Preparation Tips */}
        <section style={{ marginBottom: '60px' }}>
          <h2 style={{ 
            fontSize: '2.5rem', 
            fontWeight: 'bold', 
            marginBottom: '30px',
            color: '#2c3e50',
            textAlign: 'center'
          }}>
            <FaLightbulb style={{ marginRight: '10px', color: '#667eea' }} />
            Preparation Tips
          </h2>

          <div style={{
            background: 'white',
            padding: '40px',
            borderRadius: '15px',
            boxShadow: '0 4px 15px rgba(0,0,0,0.08)'
          }}>
            <div style={{ 
              display: 'grid',
              gridTemplateColumns: 'repeat(auto-fit, minmax(280px, 1fr))',
              gap: '25px'
            }}>
              {[
                {
                  title: "Start Early",
                  desc: "Begin preparation at least 6 months before the exam date",
                  icon: <FaClock />
                },
                {
                  title: "Practice Daily",
                  desc: "Solve at least 50 questions daily from different topics",
                  icon: <FaPencilAlt />
                },
                {
                  title: "Time Management",
                  desc: "Practice solving papers within the stipulated time limit",
                  icon: <FaChartLine />
                },
                {
                  title: "Focus on Weak Areas",
                  desc: "Identify and work on your weak subjects regularly",
                  icon: <FaCheckCircle />
                },
                {
                  title: "Mock Tests",
                  desc: "Take regular mock tests to assess your preparation level",
                  icon: <FaFileAlt />
                },
                {
                  title: "Revision",
                  desc: "Regular revision of all topics is key to success",
                  icon: <FaBook />
                }
              ].map((tip, idx) => (
                <div key={idx} style={{
                  padding: '25px',
                  border: '2px solid #e8e8e8',
                  borderRadius: '12px',
                  transition: 'all 0.3s ease'
                }}
                onMouseEnter={(e) => {
                  e.currentTarget.style.borderColor = '#667eea';
                  e.currentTarget.style.transform = 'translateY(-5px)';
                  e.currentTarget.style.boxShadow = '0 8px 20px rgba(102,126,234,0.15)';
                }}
                onMouseLeave={(e) => {
                  e.currentTarget.style.borderColor = '#e8e8e8';
                  e.currentTarget.style.transform = 'translateY(0)';
                  e.currentTarget.style.boxShadow = 'none';
                }}>
                  <div style={{ 
                    fontSize: '2.5rem',
                    color: '#667eea',
                    marginBottom: '15px'
                  }}>
                    {tip.icon}
                  </div>
                  <h4 style={{ 
                    fontSize: '1.3rem',
                    fontWeight: 'bold',
                    marginBottom: '10px',
                    color: '#2c3e50'
                  }}>
                    {tip.title}
                  </h4>
                  <p style={{ 
                    color: '#666',
                    lineHeight: '1.6',
                    margin: 0
                  }}>
                    {tip.desc}
                  </p>
                </div>
              ))}
            </div>
          </div>
        </section>

        {/* Course Packages */}
        <section style={{ marginBottom: '60px' }}>
          <h2 style={{ 
            fontSize: '2.5rem', 
            fontWeight: 'bold', 
            marginBottom: '30px',
            color: '#2c3e50',
            textAlign: 'center'
          }}>
            <FaRupeeSign style={{ marginRight: '10px', color: '#667eea' }} />
            Course Packages
          </h2>

          <div style={{
            display: 'grid',
            gridTemplateColumns: 'repeat(auto-fit, minmax(300px, 1fr))',
            gap: '30px'
          }}>
            {[
              {
                name: "Basic Package",
                price: "4,999",
                duration: "3 Months",
                features: [
                  "Complete Study Material",
                  "Video Lectures",
                  "10 Mock Tests",
                  "Doubt Resolution",
                  "Email Support"
                ],
                gradient: "linear-gradient(135deg, #667eea 0%, #764ba2 100%)"
              },
              {
                name: "Standard Package",
                price: "7,999",
                duration: "6 Months",
                features: [
                  "Everything in Basic",
                  "Live Classes",
                  "25 Mock Tests",
                  "Previous Year Papers",
                  "Weekly Assessments",
                  "WhatsApp Support"
                ],
                gradient: "linear-gradient(135deg, #f093fb 0%, #f5576c 100%)",
                popular: true
              },
              {
                name: "Premium Package",
                price: "12,999",
                duration: "12 Months",
                features: [
                  "Everything in Standard",
                  "Personal Mentor",
                  "Unlimited Mock Tests",
                  "One-on-One Doubt Sessions",
                  "Performance Analysis",
                  "Offline Study Material",
                  "24/7 Support"
                ],
                gradient: "linear-gradient(135deg, #43e97b 0%, #38f9d7 100%)"
              }
            ].map((pkg, idx) => (
              <div key={idx} style={{
                background: 'white',
                borderRadius: '20px',
                overflow: 'hidden',
                boxShadow: pkg.popular ? '0 12px 40px rgba(102,126,234,0.3)' : '0 4px 15px rgba(0,0,0,0.08)',
                border: pkg.popular ? '3px solid #667eea' : '1px solid #e8e8e8',
                position: 'relative',
                transform: pkg.popular ? 'scale(1.05)' : 'scale(1)',
                transition: 'all 0.3s ease'
              }}
              onMouseEnter={(e) => {
                e.currentTarget.style.transform = pkg.popular ? 'scale(1.08)' : 'scale(1.03)';
                e.currentTarget.style.boxShadow = '0 15px 45px rgba(102,126,234,0.3)';
              }}
              onMouseLeave={(e) => {
                e.currentTarget.style.transform = pkg.popular ? 'scale(1.05)' : 'scale(1)';
                e.currentTarget.style.boxShadow = pkg.popular ? '0 12px 40px rgba(102,126,234,0.3)' : '0 4px 15px rgba(0,0,0,0.08)';
              }}>
                {pkg.popular && (
                  <div style={{
                    position: 'absolute',
                    top: '20px',
                    right: '-35px',
                    background: '#FFD700',
                    color: '#333',
                    padding: '5px 40px',
                    fontSize: '0.85rem',
                    fontWeight: 'bold',
                    transform: 'rotate(45deg)',
                    boxShadow: '0 4px 10px rgba(0,0,0,0.2)'
                  }}>
                    POPULAR
                  </div>
                )}
                
                <div style={{
                  background: pkg.gradient,
                  padding: '40px 30px',
                  textAlign: 'center',
                  color: 'white'
                }}>
                  <h3 style={{ 
                    fontSize: '1.8rem',
                    fontWeight: 'bold',
                    marginBottom: '15px'
                  }}>
                    {pkg.name}
                  </h3>
                  <div style={{ fontSize: '3rem', fontWeight: 'bold', marginBottom: '10px' }}>
                    ₹{pkg.price}
                  </div>
                  <div style={{ fontSize: '1.1rem', opacity: 0.9 }}>
                    {pkg.duration}
                  </div>
                </div>

                <div style={{ padding: '30px' }}>
                  <ul style={{ 
                    listStyle: 'none',
                    padding: 0,
                    margin: '0 0 25px 0'
                  }}>
                    {pkg.features.map((feature, i) => (
                      <li key={i} style={{
                        padding: '12px 0',
                        borderBottom: i < pkg.features.length - 1 ? '1px solid #f0f0f0' : 'none',
                        display: 'flex',
                        alignItems: 'center',
                        gap: '10px',
                        color: '#555'
                      }}>
                        <FaCheckCircle style={{ color: '#43e97b', fontSize: '1.2rem', flexShrink: 0 }} />
                        <span>{feature}</span>
                      </li>
                    ))}
                  </ul>

                  <button style={{
                    width: '100%',
                    padding: '15px',
                    borderRadius: '10px',
                    border: 'none',
                    background: pkg.gradient,
                    color: 'white',
                    fontSize: '1.1rem',
                    fontWeight: 'bold',
                    cursor: 'pointer',
                    transition: 'all 0.3s ease'
                  }}
                  onClick={() => window.location.href = '/register'}
                  onMouseEnter={(e) => {
                    e.currentTarget.style.transform = 'translateY(-3px)';
                    e.currentTarget.style.boxShadow = '0 8px 20px rgba(0,0,0,0.2)';
                  }}
                  onMouseLeave={(e) => {
                    e.currentTarget.style.transform = 'translateY(0)';
                    e.currentTarget.style.boxShadow = 'none';
                  }}>
                    Enroll Now
                  </button>
                </div>
              </div>
            ))}
          </div>
        </section>

        {/* FAQs */}
        <section style={{ marginBottom: '60px' }}>
          <h2 style={{ 
            fontSize: '2.5rem', 
            fontWeight: 'bold', 
            marginBottom: '30px',
            color: '#2c3e50',
            textAlign: 'center'
          }}>
            Frequently Asked Questions
          </h2>

          <div style={{
            background: 'white',
            borderRadius: '15px',
            boxShadow: '0 4px 15px rgba(0,0,0,0.08)',
            overflow: 'hidden'
          }}>
            {[
              {
                q: "What is the eligibility for JNVST?",
                a: `For Class 6: Students studying in Class 5 with age 9-13 years. For Class 9: Students studying in Class 8 with age 13-16 years. For Class 11: Students who passed Class 10 with age 14-18 years.`
              },
              {
                q: "Is there any application fee for JNVST?",
                a: "No, JNVST application is completely free for all candidates across all categories."
              },
              {
                q: "How many seats are available in each Navodaya Vidyalaya?",
                a: "Each JNV has approximately 80 seats for Class 6, 40-50 seats for Class 9, and limited seats for Class 11 lateral entry."
              },
              {
                q: "What is the selection criteria?",
                a: "Selection is purely based on the merit in the entrance examination. Rural candidates get 75% reservation and urban get 25%."
              },
              {
                q: "Can students from any state apply?",
                a: "Students can only apply to the JNV in their home district. They must be a resident of that particular district."
              },
              {
                q: "What is the exam pattern?",
                a: "The exam consists of objective-type multiple-choice questions. The pattern varies for Class 6, 9, and 11 admissions."
              }
            ].map((faq, idx) => (
              <div key={idx} style={{
                padding: '30px',
                borderBottom: idx < 5 ? '1px solid #e8e8e8' : 'none'
              }}>
                <h4 style={{ 
                  fontSize: '1.3rem',
                  fontWeight: 'bold',
                  marginBottom: '15px',
                  color: '#667eea',
                  display: 'flex',
                  alignItems: 'flex-start',
                  gap: '10px'
                }}>
                  <span style={{ flexShrink: 0 }}>Q{idx + 1}.</span>
                  <span>{faq.q}</span>
                </h4>
                <p style={{ 
                  color: '#666',
                  lineHeight: '1.8',
                  margin: '0 0 0 35px',
                  fontSize: '1.05rem'
                }}>
                  {faq.a}
                </p>
              </div>
            ))}
          </div>
        </section>

        {/* Final CTA */}
        <section>
          <div style={{
            background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
            padding: '60px 40px',
            borderRadius: '20px',
            textAlign: 'center',
            color: 'white'
          }}>
            <h2 style={{ 
              fontSize: '2.5rem',
              fontWeight: 'bold',
              marginBottom: '20px'
            }}>
              Ready to Join Navodaya Vidyalaya?
            </h2>
            <p style={{ 
              fontSize: '1.3rem',
              marginBottom: '35px',
              opacity: 0.95,
              maxWidth: '700px',
              margin: '0 auto 35px'
            }}>
              Start your preparation today with expert guidance and comprehensive study material
            </p>
            <div style={{ 
              display: 'flex',
              gap: '20px',
              justifyContent: 'center',
              flexWrap: 'wrap'
            }}>
              <button 
                onClick={() => window.location.href = '/enroll'}
                style={{
                  background: 'white',
                  color: '#000000ff',
                  padding: '18px 45px',
                  borderRadius: '30px',
                  border: 'none',
                  fontSize: '1.2rem',
                  fontWeight: 'bold',
                  cursor: 'pointer',
                  boxShadow: '0 8px 20px rgba(0,0,0,0.2)',
                  transition: 'all 0.3s ease'
                }}
                onMouseEnter={(e) => {
                  e.currentTarget.style.transform = 'translateY(-5px)';
                  e.currentTarget.style.boxShadow = '0 12px 30px rgba(0,0,0,0.3)';
                }}
                onMouseLeave={(e) => {
                  e.currentTarget.style.transform = 'translateY(0)';
                  e.currentTarget.style.boxShadow = '0 8px 20px rgba(0,0,0,0.2)';
                }}>
                Register for Class {selectedClass}
              </button>
              <button style={{
                background: 'rgba(255,255,255,0.2)',
                color: 'white',
                padding: '18px 45px',
                borderRadius: '30px',
                border: '2px solid white',
                fontSize: '1.2rem',
                fontWeight: 'bold',
                cursor: 'pointer',
                transition: 'all 0.3s ease'
              }}
              onClick={() => window.location.href = '/contact'}
              onMouseEnter={(e) => {
                e.currentTarget.style.background = 'white';
                e.currentTarget.style.color = '#667eea';
              }}
              onMouseLeave={(e) => {
                e.currentTarget.style.background = 'rgba(255,255,255,0.2)';
                e.currentTarget.style.color = 'white';
              }}>
                Contact Us
              </button>
            </div>
          </div>
        </section>
      </div>

      {/* Footer Note */}
      <div style={{
        background: '#2c3e50',
        color: 'white',
        padding: '30px 20px',
        textAlign: 'center',
        marginTop: '20px'
      }}>
      
        <p style={{ margin: 0, opacity: 0.8 }}>
          For more information, visit official website: <a href="https://navodaya.gov.in" target="_blank" rel="noopener noreferrer" style={{ color: '#43e97b', textDecoration: 'none' }}>navodaya.gov.in</a>
        </p>
      </div>
    </div>
  );
};

export default JNVSTPage;